import { ensureSites } from "../domain/seed.js";

let S;

const ui = { user: null, view: "overview", jvDraft: null, err: "", lvErr: "" };

const KEY = "milltech-one-demo-v1";

function save() {
  globalThis.dispatchEvent?.(new CustomEvent("milltech:save"));
}

function replaceState(data) {
  S = data;
}

function initializeState(data, user) {
  S = ensureSites(data);
  ui.user = user;
}

export { S, ui, KEY, save, replaceState, initializeState };
